module.exports = __webpack_public_path__ + "img/pole-status-green.93f57c8d.webp";